import { ThemeColors } from '~/themes/colors'

interface ContactCardsListColors {
  EmptySearchResultsIcon: {
    FontColor: ThemeColors
  }
  EmptySearchResultsStatusText: {
    FontColor: ThemeColors
  }
  EmptySearchResultsText: {
    FontColor: ThemeColors
  }
  SearchResultsProgress: {
    ProgressColor: ThemeColors
    TrackColor: ThemeColors
  }
  EmptySearchText: {
    FontColor: ThemeColors
  }
  EmptySearchIcon: {
    FontColor: ThemeColors
  }
  ResultsHeader: {
    BorderColor: ThemeColors
    Subtext: {
      FontColor: ThemeColors
    }
  }
}
export const contactCardsListColors: ContactCardsListColors = {
  EmptySearchResultsIcon: {
    FontColor: {
      default: 'gray.700',
    },
  },
  EmptySearchResultsStatusText: {
    FontColor: {
      default: 'gray.800',
    },
  },
  EmptySearchResultsText: {
    FontColor: {
      default: 'gray.800',
    },
  },
  SearchResultsProgress: {
    ProgressColor: {
      default: 'gray.400',
    },
    TrackColor: {
      default: 'gray.700',
    },
  },
  EmptySearchText: {
    FontColor: {
      default: 'gray.700',
    },
  },
  EmptySearchIcon: {
    FontColor: {
      default: 'gray.700',
    },
  },
  ResultsHeader: {
    BorderColor: {
      default: 'gray.400',
    },
    Subtext: {
      FontColor: {
        default: 'gray.800',
      },
    },
  },
}
